import { Link } from "react-router-dom";
import { novels } from "@/mocks/novels";

export default function FeaturedGrid() {
  const featuredNovels = novels.filter((n) => n.featured);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-2">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          编辑精心挑选，本本都是心头好
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop="">
          {featuredNovels.map((novel) => (
            <Link
              key={novel.id}
              to={`/article/${novel.id}`}
              className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={novel.coverImage}
                  alt={novel.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-medium rounded-full whitespace-nowrap">
                    {novel.category}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-0.5 bg-background-50/90 px-2 py-1 rounded-full">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-xs font-semibold text-foreground-800">
                    {novel.rating}
                  </span>
                </div>
              </div>

              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2 line-clamp-1">
                  {novel.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
                  {novel.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">
                    {novel.author}
                  </span>
                  <div className="flex items-center gap-1 flex-wrap">
                    {novel.tags.slice(0, 2).map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full whitespace-nowrap"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}